export const HEADER_PRIMARY_MENU = "header-primary-menu";
export const COLLAPSE_ALL = 'collapseAll';
export const HIDE_ALL = 'hideAll';
export const HIDE_TOP_NAV = 'hideTopNav';